import { OperatorInterface } from "utils"

export const MFC_NAME = "MFC"
export const MFC_ID = "MF"
export const MFC_SUBDOMAIN = "mfc"
export const MFC_CONTACT_EMAIL = "contact@mfc.eu"

export const mfcConfiguration: OperatorInterface = 
    {
		name: "MFC",
		id: MFC_ID,
		subDomain: MFC_SUBDOMAIN,
        url: "mfc.o-code.co",
		folderName: "mfc",
        cguUrl: "https://legal.o-code.co/bike/MFC/Owner/CGU/fr/CGU_MFC_20240101.pdf",
        legalNoticeUrl: "https://legal.o-code.co/bike/MFC/Owner/ML/fr/MentionsLegales_MFC_20240101.pdf",
	    privacyPolicyUrl: "https://legal.o-code.co/bike/MFC/Owner/PDC/fr/PolitiqueDeConfidentialite_MFC_20240101.pdf",
		faqAccordionLength: 7,
		theme: {
            primaryColor: "#213C88",
            primaryColorHover: "#18337c",
            secondaryColor: "#D5103C",
            formBackgroundColor: "#F5F7F7",
            insaleBike: "#3A77C5",
            insaleBikeHover: "#4075b7",
            secondaryColorLighten: "#F6AEA1",
            secondaryColorHover: "#c9183e",
            placeholderColor: "#1B1464",
		  }
    }